// source: https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
export const DisplayableImageContentTypes = [
    'image/apng',
    'image/avif',
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/svg+xml',
    'image/webp'
];
